import * as React from "react";

const iconCheckboxUnchecked = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm0 21.75a.25.25 0 0 1-.25.25H2.25a.248.248 0 0 1-.25-.25V2.249A.249.249 0 0 1 2.25 2h19.5a.25.25 0 0 1 .25.25v19.5Z" />
  </svg>
);

export default iconCheckboxUnchecked;
